var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crud_module--get_by_list"},[(_vm.action == 'List')?_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }